import { ReactNode } from 'react';
import ProgressLoader from './circular-progress-loader/progress-loader';
import styles from './basic-loader.module.scss';
import stylesBlocks from './self-building-square-loader.module.scss';

export enum LoaderType {
  Spinner,
  Blocks,
  Progress,
}

export const SelfBuildingSquareSpinner = () => {
  return (
    <div className={`${stylesBlocks.loader}`}>
      {Array.from({ length: 9 }).map((val, index) => (
        <div key={index} className={`${stylesBlocks.square} ${index % 3 === 0 ? ' clear' : ''}`} />
      ))}
    </div>
  );
};

export const BasicLoader = ({
  isLoading,
  type = LoaderType.Blocks,
  children,
  fullHeight,
  topOffset = false,
}: {
  isLoading: boolean;
  type?: LoaderType;
  children?: ReactNode;
  fullHeight?: boolean;
  topOffset?: boolean;
}) => {
  return isLoading
    ? {
        [LoaderType.Blocks]: (
          <div
            className={`${fullHeight ? stylesBlocks.fullHeightContainer : ''} ${
              topOffset ? stylesBlocks.topMenuOffset : ''
            }`}
          >
            <SelfBuildingSquareSpinner></SelfBuildingSquareSpinner>
          </div>
        ),
        [LoaderType.Spinner]: (
          <div className={styles.loaderContainer}>
            <div className={styles.innerContainer}>
              <div className={styles.spinner}></div>
            </div>
          </div>
        ),
        [LoaderType.Progress]: <ProgressLoader />,
      }[type]
    : children || null;
};